import { render } from "./PanelPublicistaGeoMeta.vue?vue&type=template&id=66076da6&scoped=true"
import script from "./PanelPublicistaGeoMeta.vue?vue&type=script&lang=js"
export * from "./PanelPublicistaGeoMeta.vue?vue&type=script&lang=js"

import "./PanelPublicistaGeoMeta.vue?vue&type=style&index=0&id=66076da6&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66076da6"]])

export default __exports__